import classNames from 'classnames';
import type { PropsWithChildren } from 'react';
import React, { useContext } from 'react';

import { RicosContext, RicosViewerContext } from './../../../../../ricos-context/index.js';
import { Node_Type } from './../../../../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { Link } from './../../../../../ricos-schema/next-schema/index.js';
import { getLinkHrefUrl } from './../../../../../_shared/link/get-link-href-url.js';
import {
  addAnchorTagToUrl,
  anchorScroll,
  convertRelObjectToString,
} from './../../../../../wix-rich-content-common/index.js';

import classes from './link-viewer-wrapper-scss.js';

type LinkViewerWrapperProps = PropsWithChildren & {
  link?: Link;
  nodeType: Node_Type;
};

export const LinkViewerWrapper: React.FC<LinkViewerWrapperProps> = ({
  children,
  nodeType,
  link,
}) => {
  const { anchorTarget, baseUrl, customAnchorScroll } = useContext(RicosViewerContext);
  const { tabIndex } = useContext(RicosContext);

  if (!(link && nodeType !== Node_Type.BUTTON)) {
    return <>{children}</>;
  }

  return (
    <a
      className={classNames(classes.link, 'has-custom-focus', {
        [classes.anchor]: link,
      })}
      tabIndex={tabIndex}
      href={link ? getLinkHrefUrl(link, baseUrl) : undefined}
      target={link.target ? `_${link.target.toLowerCase()}` : anchorTarget}
      rel={link.rel && convertRelObjectToString(link.rel)}
      onClick={
        link?.anchor
          ? (e: React.MouseEvent) => {
              if (customAnchorScroll) {
                return customAnchorScroll(e, link?.anchor as string);
              }

              const anchorRefId = `viewer-${link?.anchor}`;
              const element = document.getElementById(anchorRefId);
              if (!element) {
                return;
              }
              addAnchorTagToUrl(anchorRefId);
              anchorScroll(element);
            }
          : undefined
      }
    >
      {children}
    </a>
  );
};
